module.exports = __webpack_public_path__ + "img/7.00949a9e.jpg";